import { NavLink, Route, Routes } from "react-router-dom";
import { Heart, UserRound } from "lucide-react";
import { TopBar } from "../../components/TopBar";
import { SignOutButton } from "../../components/AccountMenu";
import { useNoindex } from "../../hooks/useNoindex";
import MyProfile from "./MyProfile";
import MyMatches from "./MyMatches";
import SharedProfileDetail from "./SharedProfileDetail";

const tab = ({ isActive }) =>
  `inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${isActive ? "bg-[#7A0016] text-[#F5E6BA]" : "border border-[#D4AF37]/60 bg-white text-[#7A0016] hover:bg-[#F5E6BA]/50"}`;

export default function PortalApp() {
  useNoindex();
  return (
    <div className="rmm-bg min-h-screen">
      <TopBar right={<SignOutButton />} />
      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-10">
        <nav className="mb-6 flex gap-2" data-testid="portal-nav">
          <NavLink to="/portal" end className={tab} data-testid="portal-nav-profile"><UserRound className="h-4 w-4" />My Profile</NavLink>
          <NavLink to="/portal/matches" className={tab} data-testid="portal-nav-matches"><Heart className="h-4 w-4" />My Matches</NavLink>
        </nav>
        <Routes>
          <Route index element={<MyProfile />} />
          <Route path="matches" element={<MyMatches />} />
          <Route path="matches/:shareId" element={<SharedProfileDetail />} />
          <Route path="*" element={<p data-testid="portal-not-found" className="rmm-card p-8 text-sm text-[#8C6A6C]">Not found.</p>} />
        </Routes>
      </main>
    </div>
  );
}
